export const LIGHT_BLUE="#ADD0E2"

